import min from 'lodash/min';
export const imageDataToMediaUrl = ({ url, width, height }, { maxWidth = 1000, maxHeight = 1000, quality = 90, type = 'fit', format = 'webp', blur = 0, } = {}) => {
    //handle case if url is absolute
    if (url) {
        if (url.startsWith('http') && !url.includes('static.wixstatic.com')) {
            return url;
        }
        if (url.endsWith('.svg')) {
            return `https://static.wixstatic.com/${url}`;
        }
        const [finalWidth, finalHeight] = [
            Math.floor(min([maxWidth, width])),
            Math.floor(min([maxHeight, height])),
        ];
        const blurParam = blur > 0 ? `blur_${blur},` : '';
        const imgUrl = url.startsWith('https://static.wixstatic.com')
            ? url
            : `https://static.wixstatic.com/${url}`;
        return `${imgUrl}/v1/${type}/w_${finalWidth},h_${finalHeight},${blurParam}al_c,q_${quality}/file.${format}`;
    }
    return '';
};
//# sourceMappingURL=image.js.map